<crm-single-select
  #singleSelectComponent
  [options]="externalUsers"
  [(selectedItem)]="_selectedExternalUser"
  (selectedItemChange)="onSelect($event)"
  [label]="isFloatLabel ? 'Пользователь' : ''"
  [showClear]="showClear"
  [placeholder]="placeholder"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [appendTo]="appendTo"
  [disabled]="disabled"
  [loading]="loading || selectionLoading"
  optionLabel="profile.name"
  filterBy="profile.name"
  (onShow)="onShowPanel()"
  (onFilter)="search($event.filter)">
  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-single-select>
